export class Constants {
  static MaxInt = 2147483647;
  static CountryPL = 616;
  static DefaultDateLocalization = 'pl-PL';
  static ProvisionPercentageType = 1;
  static ProvisionValueType = 2;
  static SuperAdminRoleId = 1;
  static CompanyPersonType = 2;
  static PhysicalPersonType = 1;
  static MinCarProductionYear = 1900;
  static EmptyGuid = '00000000-0000-0000-0000-000000000000';
  static ProofDocumentKindIdMandatory = 1;
  static ProofDocumentConformityIdNotDelivered = 1;
  static ProofDocumentConformityIdConfirmed = 2;
  static ProofDocumentRequiredFromClient = 1;
  static DefaultInspectionForecastedDuration = 2;
  static DefaultRepairForecastedDuration = 8;
  static DefaultRepairAssemblyForecastedDuration = 2;
  static DefaultPartsOrderPartnerId = 1;
  static DefaultVatRateId = 1;
  static DefaultVatRate = 0.23;
  static PartsOrderWindowName ='_partsOrderWindow'
  static Degrees90 = 90;
  static Degrees270 = 270;
  static RepairAssemblyElementOther = 9;
  static ColorTypeOther = 12;
  static IbanFormatPL = '00 0000 0000 0000 0000 0000 0000';
  static CarRentalByWorkshop = 4;
  static MaxRetryFileUpload = 10;
  static FiscalIdentifierLength = 10;
} 
